import type { ArcanaIdentity } from '../arcana-identities';
import type { DeckId, DeckDefinition } from '../../../types/deck';
import { PLACEHOLDER_DESCRIPTION, type ArcanaDescription } from '../data/arcana-descriptions';
import { THOTH } from './thoth';
import { SOLA_BUSCA } from './sola-busca';
import { RIDER_WAITE } from './rider-waite';

/** Display order for the deck switcher (cycles through this list). */
export const DECK_ORDER: DeckId[] = ['thoth', 'sola-busca', 'rider-waite'];

/** All available decks, keyed by deck id. */
export const DECKS: Record<DeckId, DeckDefinition> = {
    thoth: THOTH,
    'sola-busca': SOLA_BUSCA,
    'rider-waite': RIDER_WAITE,
};

/** The deck the app opens with. */
export const DEFAULT_DECK: DeckId = 'thoth';

/**
 * Deck-aware description accessor: the deck-aware counterpart of
 * `getArcanaDescription`. Falls back to the shared placeholder when a deck
 * has no entry for an identity, so the UI never renders an empty body.
 */
export function getDeckDescription(deck: DeckDefinition, identity: ArcanaIdentity): ArcanaDescription {
    return deck.descriptions[identity] ?? PLACEHOLDER_DESCRIPTION;
}

/** The next deck in the switcher cycle. */
export function nextDeckId(current: DeckId): DeckId {
    return DECK_ORDER[(DECK_ORDER.indexOf(current) + 1) % DECK_ORDER.length];
}
